export default "__VITE_ASSET__76af4476__"